import {
  Resource_AppointmentRequestMsg,
  Resource_AppointmentRequestStatus,
} from '@/generated/graphql';
import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import styles from './appointment-details.module.scss';

interface AppointmentArchivingProps {
  appointmentRequest: Maybe<Resource_AppointmentRequestMsg> | undefined;
}

export const AppointmentRequestArchiving: FC<AppointmentArchivingProps> = ({
  appointmentRequest,
}) => {
  const { formatMessage } = useIntl();
  const archived =
    appointmentRequest?.status ===
    Resource_AppointmentRequestStatus.AppointmentRequestStatusArchived;

  return archived ? (
    <Card className={styles.archived}>
      <Title level={3} style={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'appointment.archiving' })}
      </Title>
      <p>{formatMessage({ id: 'appointment.archiving.description' })}</p>
    </Card>
  ) : null;
};
